import { render } from "./reimbursement.vue?vue&type=template&id=6b940e53&scoped=true"
import script from "./reimbursement.vue?vue&type=script&lang=js"
export * from "./reimbursement.vue?vue&type=script&lang=js"

import "./reimbursement.vue?vue&type=style&index=0&id=6b940e53&scoped=true&lang=css"

import exportComponent from "D:\\AICodeSpace\\KaungAdmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b940e53"]])

export default __exports__